var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 25.5,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "#85909F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.47372 17.5L12 1L21.5263 17.5H2.47372Z",
    stroke: "#85909F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeShape);
export default __webpack_public_path__ + "static/media/changeShape.56df87c91d2141e77fc7de7aef4183b3.svg";
export { ForwardRef as ReactComponent };